// TODO: hack till the content is managed else where
export enum KNOWN_TITLES {
  HOPE = "A Message of Hope",
  LOVE = "A Message of Love",
  JOY = "A Message of Joy",
}
